import { IContent } from "@kunduz/data-access-cms-api";
import { useRouter } from "next/router";
import React, { ReactElement, useEffect, useMemo, useState } from "react";
import { RedirectionWithContext } from "../redirection";
import { Dialog } from "@kunduz/ui-molecules";
import styles from "./modalComponent.module.scss";

export const ModalComponent = (props: Props): ReactElement => {
  const { data } = props;
  const router = useRouter();
  const [render, setRender] = useState(false);

  const { modal } = router.query as any;
  const modalValues = useMemo(() => (modal ? modal.split(",") : []), [modal]);

  useEffect(() => {
    if (modalValues.some((m: string) => data.query_param.includes(m))) {
      setRender(true);
    } else {
      setRender(false);
    }
  }, [modalValues, data.query_param]);

  const onClose = () => {
    setRender(false);

    const cleanPath = window.location.origin + "/" + window.location.pathname;
    router.push(cleanPath, undefined, { shallow: true });
  };

  return data.components.map((c, i) => {
    switch (c.component_type) {
      case "redirection-component":
        return (
          <Dialog
            key={i}
            opened={render}
            closeOnClickOutside
            withPortal
            withOverlay
            close={onClose}
            contentClassName={styles.redirectionComponentContainer}
          >
            <RedirectionWithContext
              title={(c.data as IContent.RedirectionComponentData)?.title}
              description={
                (c.data as IContent.RedirectionComponentData)?.description
              }
              buttonItemsTitle={
                (c.data as IContent.RedirectionComponentData)
                  ?.button_items_title
              }
              buttonItems={
                (c.data as IContent.RedirectionComponentData)?.button_items
              }
              image={(c.data as IContent.RedirectionComponentData)?.image}
              rankingItems={
                (c.data as IContent.RedirectionComponentData)?.ranking_items
              }
              className={styles.redirectionComponentContent}
            />
          </Dialog>
        );

      default:
        return <></>;
    }
  }) as any;
};

interface Props {
  data: IContent.ModalComponentData;
}
